// extracted by mini-css-extract-plugin
module.exports =  {"modal-footer":"_93444fe79c--modal-footer--rgHOZ"};